import { Component } from '@angular/core';

@Component({
  selector: 'date-picker-specs',
  templateUrl: './date-picker-specs.component.html',
  styleUrls: ['./date-picker-specs.component.sass']
})
export class DatePickerSpecsComponent {
  public component = window.location.protocol + '//' + window.location.host + '/design-specs-measure/date-picker/';

  constructor() { }

  ngOnInit(): void {
  }

  clickEvent(route) {
    if(route == 'light') {
      window.open(this.component, "_blank");
    }
  }
}
